import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import React, { useCallback, useRef } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { ViewPreInvoiceStorageTableRow } from '../../models/ViewPreInvoices';

interface ViewPreInvoiceStoragesAgGridTableProps {
  rows: ViewPreInvoiceStorageTableRow[];
  isLoading?: boolean;
  isFetching?: boolean;
  className?: string;
  selectedColumns?: string[];
  selectedStorages?: Set<string>;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  onSelectionChanged?: (selectedIds: Set<string>) => void;
  onRemoveStorage?: (storageId: number) => void;
  showActions?: boolean;
}

export const ViewPreInvoiceStoragesAgGridTable = React.memo(function ViewPreInvoiceStoragesAgGridTable({
  rows,
  selectedColumns = [],
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
  onSelectionChanged,
  onRemoveStorage,
  showActions = false,
}: ViewPreInvoiceStoragesAgGridTableProps) {
  const gridRef = useRef<AgGridTableRef>(null);

  const { filteredColumnDefs } = useAgGridColumns({
    selectedColumns,
    isStorageType: true,
    showActions: showActions && !!onRemoveStorage,
    onRemoveStorage,
  });

  const handleSelectionChanged = useCallback(
    (selectedRows: ViewPreInvoiceStorageTableRow[]) => {
      const selectedIds = new Set(selectedRows.map((row) => row.id).filter(Boolean) as string[]);
      onSelectionChanged?.(selectedIds);
    },
    [onSelectionChanged],
  );

  return (
    <div className="w-full relative flex flex-col flex-1 min-h-0">
      <div className="flex-1 min-h-0 flex flex-col">
        <AgGridTable
          ref={gridRef}
          data={rows}
          columnDefs={filteredColumnDefs as ColDef[]}
          height="100%"
          enableSelection={true}
          onSelectionChanged={handleSelectionChanged}
          onGridReady={() => undefined}
          className="rounded-lg shadow-sm min-h-0 flex-1"
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          gridOptions={{}}
          sorting={sorting}
          onSortingChange={onSortingChange}
          rowHeight={50}
        />
      </div>
    </div>
  );
});
